export default __webpack_public_path__ + "static/media/css-icon.bf84185c.svg";